import { Dropdown } from "antd"
import { Mail } from "lucide-react"
import { useTranslation } from "react-i18next"

import linkedinLogo from "~/assets/linkedin.png"
import PersonBrief from "~/containers/person-brief/person-details"
import useChampionsTrackingStore from "~/store/champions-tracking"
import { EmailTemplateType } from "~/types/accounts"

const BriefCombo = ({
  people,
  accountData,
  customPersonas,
  streaming,
  personaLoading
}: {
  people: any
  accountData: any
  customPersonas: any
  selectedPerson?: any
  streaming?: boolean
  personaLoading?: boolean
}) => {
  const { t } = useTranslation()
  const setShowMessageTemplateModal = useChampionsTrackingStore(
    (store) => store.setShowMessageTemplateModal
  )
  const getPersonaForUrl = (peopleUrl: string) => {
    const matchedKey = Object.keys(customPersonas).find((fullUrl) =>
      fullUrl.endsWith(peopleUrl)
    )

    return matchedKey ? customPersonas[matchedKey] : null
  }

  const onClickMessageTemplate = (templateType: EmailTemplateType) => {
    setShowMessageTemplateModal({
      ...people,
      linkedin_url: people.url,
      templateType,
      opportunity_ids: people.priorities?.map((priority: any) => priority.id)
    })
  }

  const renderMessageTemplate = () => (
    <Dropdown
      placement="bottomLeft"
      trigger={["click"]}
      menu={{
        items: [
          {
            key: "LINKEDIN",
            icon: (
              <img
                src={linkedinLogo}
                alt="Linkedin icon"
                width={12}
                height={12}
              />
            ),
            label: (
              <span className="text-xs">{t("label_linkedin_message")}</span>
            ),
            onClick: () => onClickMessageTemplate?.("LINKEDIN")
          },
          {
            key: "EMAIL",
            icon: <Mail size={14} strokeWidth={1.5} />,
            label: <span className="text-xs">{t("label_email_message")}</span>,
            onClick: () => onClickMessageTemplate?.("EMAIL")
          }
        ]
      }}
    >
      <button className="dark:text-dark-6 text-dark-2 p-2 border-[0.5px] border-light-border dark:border-border rounded-lg text-xs dark:bg-dark-2 bg-white flex items-center gap-1">
        <span>{t("label_generate_message")}</span>
      </button>
    </Dropdown>
  )

  const persona = getPersonaForUrl(people?.url)

  return (
    <PersonBrief
      persona={persona}
      people={people}
      renderMessageTemplate={renderMessageTemplate}
      setIsOpen={() => {}}
      account={accountData}
      streaming={streaming}
      personaLoading={personaLoading}
    />
  )
}

export default BriefCombo
